
import { sendPasswordResetEmail } from "firebase/auth";
import React from "react";
import { useState ,useEffect} from "react";
import { Link } from "react-router-dom";
import { auth } from "../Firebase";

// *** value attribute remember ***

const ForgotPw = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  
  const [open,setOpen] = useState("");
  
  
  useEffect(() => {
    if(open){
    setTimeout(() => {
      setOpen(false);
    }, 6000);}
  },[open]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    await sendPasswordResetEmail(auth, email)    // Make sure to keep extra parameter to redirect to login page
      .then(() => {
        setOpen(true);
        setMessage("Reset instructions is sent to the registered email. Please check inbox and spam.");
        console.log("Reset prompt is sent to the registered email");
        
      })
      .catch(() => {
        setOpen(true);
        setMessage("Failed to reset. Please enter the registered email.");
        console.log("Failed to reset");
      });
  };
  return (
    <div className="sign-overlay">
      <div className="sign-container">
        <form className="sign-form">
          <h1 className=" heading">
            RESET PASSWORD<div className="bottom_line"></div>
          </h1>
       
          <div className="input-container">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              required
              className="input-field"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          {open && <div className='note' style={{paddingTop:"0.5rem",display:"flex",justifyContent:"center",alignItems:"center",width:"80%",fontSize:"0.8rem"}}>
            <span style={{textAlign:"center"}}>{message}</span>
            </div>}
          <Link to="/signup">Do not have an account? Sign up!</Link>
          <div className="input-bot">
            <p>
              <Link to="/login">Login?</Link>
            </p>
            <button
              type="submit"
              className="button-62"
              onClick={(e) => handleSubmit(e)}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPw;
